module.exports = __webpack_public_path__ + "static/img/liping.803b2dff.jpg";